module.exports = __webpack_public_path__ + "img/50-ABITO-COCO-U-COLORI-LINO-STAMPE-LINO1.928cd6c9.jpg";